import { Globe } from "lucide-react";

export default function SiteFooter({ settings }) {
  return (
    <footer className="relative border-t border-slate-600/30 py-12 bg-gradient-to-b from-transparent to-[#03040a]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex flex-col md:flex-row gap-6 justify-between items-center">
        <span className="flex items-center gap-3 font-display tracking-[0.3em] text-slate-200 ">
          <img src="/assets/koselig-icon.png" alt="" className="w-8 h-8" />{settings.server_name}
        </span>
        <div className="flex items-center gap-6 text-xs tracking-[0.2em] text-slate-500">
          {settings.discord_url && <a href={settings.discord_url} target="_blank" rel="noreferrer" className="hover:text-[#8b95ff] transition-colors" data-testid="footer-discord">Discord</a>}
          {settings.website_url && <a href={settings.website_url} target="_blank" rel="noreferrer" className="hover:text-amber-300 transition-colors flex items-center gap-1" data-testid="footer-website"><Globe size={12} /> Forum</a>}
          <a href="mailto:kontakt@koselig2.pl" className="hover:text-amber-300 transition-colors" data-testid="footer-mail">kontakt@koselig2.pl</a>
        </div>
        <span className="text-xs text-slate-600 text-center md:text-right">Metin2 jest znakiem towarowym Webzen Inc. Serwer prywatny, niezwiązany z Gameforge.</span>
      </div>
    </footer>
  );
}
